export default function StreamInfo() {
  return (
    <div style={{ display: "grid", gap: 12 }}>
      <h2 style={{ margin: 0 }}>Live Stream Studio</h2>
      <p style={{ margin: 0, lineHeight: 1.6 }}>
        Capture camera, microphone, and the Oikos Live Display into one local studio preview.
        YouTube OAuth and broadcast scheduling run through the backend so stream keys stay out of the browser.
      </p>
    </div>
  );
}
